/*****************************************************************************/
/*  File Name: timeRangeBar.js                                               */
/*  Date:      June 27, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the bar that will allow users to select the time
/*             range that they want to view the data in.
/*             the default will be set to WEEKLY
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
import { Grid } from '@mui/material';
import * as TIMERANGE from '../../constants/timeRanges';
import * as MODES from '../../constants/modes';
import { useROIContext } from '../../context/roiContext';
import { useSystemContext } from '../../context/systemContext';
import styles from './styles/roi.module.scss';
import { G } from '@react-pdf/renderer';

function TimeRangeBar({ t }) {
  //Load all of the default component varaibles

  const { selectedTimeBreakdown, setSelectedBreakdown, roiMode } = useROIContext();
  const { oldSystem, upgradeSystem } = useSystemContext()
  //console.log('this is my selected Breakwodn - ---', selectedTimeBreakdown);
  //console.log('this is my oldSystem --->', oldSystem);
   //console.log('this is my upgradeSystem --->', upgradeSystem);

  return (
    <div className={styles.timeRangeSelectWrapper}>
      <Grid item xs={12} container className={styles.timeRangeSelect}>
        <Grid item xs onClick={() => setSelectedBreakdown(TIMERANGE.weekly)} className={selectedTimeBreakdown === TIMERANGE.weekly ? styles.selected : ''}>
          {TIMERANGE.weekly}
        </Grid>
        <Grid item xs onClick={() => setSelectedBreakdown(TIMERANGE.monthly)} className={selectedTimeBreakdown === TIMERANGE.monthly ? styles.selected : ''}>
          {TIMERANGE.monthly}
        </Grid>
        <Grid item xs onClick={() => setSelectedBreakdown(TIMERANGE.quarterly)} className={selectedTimeBreakdown === TIMERANGE.quarterly ? styles.selected : ''}>
          {TIMERANGE.quarterly}
        </Grid>
        <Grid item xs onClick={() => setSelectedBreakdown(TIMERANGE.annual)} className={selectedTimeBreakdown === TIMERANGE.annual ? styles.selected : ''}>
          {TIMERANGE.annual}
        </Grid>
      </Grid>
    </div>
  );
}

export default withTranslation()(TimeRangeBar);
